var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"compass-wrapper"},[_c('div',{staticClass:"compass"},[_c('img',{style:(`transform: rotate(${_vm.rotateDeg}deg);`),attrs:{"src":require("@/assets/icons/compass.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }